import { AdminMenuPrivileges } from "../privilegesProviders/AdminMenuPrivilegesProvider";
import { NavigationItem, NavigationMenu, NavigationSection } from "./types";
import { getRouteAndSelected } from "./utils";

export function getAdminNavigationMenu(
  adminMenuPrivileges: AdminMenuPrivileges,
  currentPath: string
): NavigationMenu {
  const items: Array<NavigationItem | NavigationSection> = [];

  if (adminMenuPrivileges.accountsSection) {
    const sectionItems: NavigationItem[] = [];

    if (adminMenuPrivileges.accountsSection.hcps) {
      sectionItems.push({
        label: "Workers",
        iconType: "person-male-formal",
        ...getRouteAndSelected("adminAccountsAgents", currentPath),
      });
    }
    if (adminMenuPrivileges.accountsSection.workplaces) {
      sectionItems.push({
        label: "Workplaces",
        iconType: "building-thick",
        ...getRouteAndSelected("adminAccountsFacilities", currentPath),
      });
    }
    if (adminMenuPrivileges.accountsSection.employees) {
      sectionItems.push({
        label: "Employees",
        iconType: "people",
        ...getRouteAndSelected("adminAccountsEmployees", currentPath),
      });
    }
    if (adminMenuPrivileges.accountsSection.requirements) {
      sectionItems.push({
        label: "Requirements",
        iconType: "notepad-alt",
        ...getRouteAndSelected("adminAccountsRequirement", currentPath),
      });
    }
    if (adminMenuPrivileges.accountsSection.locations) {
      sectionItems.push({
        label: "Locations",
        iconType: "location-alt",
        ...getRouteAndSelected("adminAccountsLocations", currentPath),
      });
    }
    if (adminMenuPrivileges.accountsSection.changeLog) {
      sectionItems.push({
        label: "Change Log",
        iconType: "stack-vertical",
        ...getRouteAndSelected("adminAccountsChangeLog", currentPath),
      });
    }
    if (adminMenuPrivileges.accountsSection.dnrs) {
      sectionItems.push({
        label: "DNRs",
        iconType: "padlock-locked",
        ...getRouteAndSelected("adminAccountsExclusions", currentPath),
      });
    }

    items.push({ label: "Accounts", items: sectionItems });
  }

  if (adminMenuPrivileges.shiftsSection) {
    const sectionItems: NavigationItem[] = [];

    if (adminMenuPrivileges.shiftsSection.shiftSearch) {
      sectionItems.push({
        label: "Shift Search",
        iconType: "magnifying-glass",
        ...getRouteAndSelected("adminShifts", currentPath),
      });
    }
    if (adminMenuPrivileges.shiftsSection.shiftsVerification) {
      sectionItems.push({
        label: "Shifts Verification",
        iconType: "badge-check",
        ...getRouteAndSelected("adminShiftVerification", currentPath),
      });
    }
    if (adminMenuPrivileges.shiftsSection.shiftLogs) {
      sectionItems.push({
        label: "Shift Logs",
        iconType: "folder-view",
        ...getRouteAndSelected("adminLogsShift", currentPath),
      });
    }
    if (adminMenuPrivileges.shiftsSection.timeclockRequests) {
      sectionItems.push({
        label: "Timeclock Requests",
        iconType: "clock",
        ...getRouteAndSelected("adminTimeclock", currentPath),
      });
    }
    if (adminMenuPrivileges.shiftsSection.noShows) {
      sectionItems.push({
        label: "No Shows",
        iconType: "gps-disabled",
        ...getRouteAndSelected("adminUrgentShiftNcns", currentPath),
      });
    }

    items.push({ label: "Shifts", items: sectionItems });
  }

  if (adminMenuPrivileges.invoiceSection) {
    const sectionItems: NavigationItem[] = [];

    if (adminMenuPrivileges.invoiceSection.byPeriod) {
      sectionItems.push({
        label: "By Period",
        iconType: "centered-circle",
        ...getRouteAndSelected("adminAccountsInvocingByPeriod", currentPath),
      });
    }
    if (adminMenuPrivileges.invoiceSection.byNumber) {
      sectionItems.push({
        label: "By Number",
        iconType: "dash",
        ...getRouteAndSelected("adminAccountsInvocingByNumber", currentPath),
      });
    }
    if (adminMenuPrivileges.invoiceSection.postInvoiceDisputes) {
      sectionItems.push({
        label: "Post-Invoice Disputes",
        iconType: "caret-double-right",
        ...getRouteAndSelected("adminAccountsPostInvoiceDisputes", currentPath),
      });
    }
    if (adminMenuPrivileges.invoiceSection.preInvoiceDisputes) {
      sectionItems.push({
        label: "Pre-Invoice Disputes",
        iconType: "caret-double-left",
        ...getRouteAndSelected("adminAccountsPreInvoiceDisputes", currentPath),
      });
    }

    items.push({ label: "Invoice", items: sectionItems });
  }

  if (adminMenuPrivileges.payrollSection) {
    const sectionItems: NavigationItem[] = [];

    if (adminMenuPrivileges.payrollSection.proofOfEarning) {
      sectionItems.push({
        label: "Payroll",
        iconType: "money-dollar",
        ...getRouteAndSelected("agentProof", currentPath),
      });
    }
    if (adminMenuPrivileges.payrollSection.shiftPayments) {
      sectionItems.push({
        label: "Shift Payments",
        iconType: "palm-dollar",
        ...getRouteAndSelected("adminShiftPaymentsPayRates", currentPath),
      });
    }

    items.push({ label: "Payroll", items: sectionItems });
  }

  if (adminMenuPrivileges.adminToolsSection) {
    const sectionItems: NavigationItem[] = [];

    if (adminMenuPrivileges.adminToolsSection.timekeepingVideos) {
      sectionItems.push({
        label: "Timekeeping Videos",
        iconType: "replay",
        ...getRouteAndSelected("adminToolsTimekeepingVideos", currentPath),
      });
    }
    if (adminMenuPrivileges.adminToolsSection.shiftExplainer) {
      sectionItems.push({
        label: "Shift Explainer",
        iconType: "information-circle",
        ...getRouteAndSelected("adminToolsShiftExplainer", currentPath),
      });
    }
    if (adminMenuPrivileges.adminToolsSection.badgeVerificationGrading) {
      sectionItems.push({
        label: "Badge Verification Grading",
        iconType: "badge-check",
        ...getRouteAndSelected("adminToolsBadgeVerificationGrading", currentPath),
      });
    }
    if (adminMenuPrivileges.adminToolsSection.ssnWorkerLookup) {
      sectionItems.push({
        label: "SSN Worker Lookup",
        iconType: "magnifying-glass",
        ...getRouteAndSelected("adminToolsSsnWorkerLookup", currentPath),
      });
    }
    if (adminMenuPrivileges.adminToolsSection.workerEvidences) {
      sectionItems.push({
        label: "Worker Evidences",
        iconType: "documents",
        ...getRouteAndSelected("adminToolsEvidences", currentPath),
      });
    }
    if (adminMenuPrivileges.adminToolsSection.eligibility) {
      sectionItems.push({
        label: "Eligibility",
        iconType: "documents",
        ...getRouteAndSelected("adminToolsEligibility", currentPath),
      });
    }

    items.push({ label: "Admin Tools", items: sectionItems });
  }

  if (adminMenuPrivileges.staffingSection) {
    const sectionItems: NavigationItem[] = [];

    if (adminMenuPrivileges.staffingSection.qualifications) {
      sectionItems.push({
        label: "Qualifications",
        iconType: "medal-star-alt",
        ...getRouteAndSelected("adminManageQualifications", currentPath),
      });
    }
    if (adminMenuPrivileges.staffingSection.workplaceTypes) {
      sectionItems.push({
        label: "Workplace Types",
        iconType: "house-building",
        ...getRouteAndSelected("adminManageWorkplaceTypes", currentPath),
      });
    }
    if (adminMenuPrivileges.staffingSection.skillAssessments) {
      sectionItems.push({
        label: "Skill Assessments",
        iconType: "files",
        ...getRouteAndSelected("adminManageSkillsAssessments", currentPath),
      });
    }

    items.push({ label: "Staffing", items: sectionItems });
  }

  if (adminMenuPrivileges.hiringSection) {
    const sectionItems: NavigationItem[] = [];

    if (adminMenuPrivileges.hiringSection.availability) {
      sectionItems.push({
        label: "Availability",
        iconType: "clock",
        ...getRouteAndSelected("adminPlacementsAvailability", currentPath),
      });
    }

    if (adminMenuPrivileges.hiringSection.bans) {
      sectionItems.push({
        label: "Bans",
        iconType: "notepad-problem",
        ...getRouteAndSelected("adminAccountsPlacementCandidateBans", currentPath),
      });
    }

    if (adminMenuPrivileges.hiringSection.interviews) {
      sectionItems.push({
        label: "Interviews",
        iconType: "calendar",
        ...getRouteAndSelected("adminAccountsInterviews", currentPath),
      });
    }

    if (adminMenuPrivileges.hiringSection.scraping) {
      sectionItems.push({
        label: "Scraping",
        iconType: "route",
        ...getRouteAndSelected("adminHiringScraping", currentPath),
      });
    }

    if (adminMenuPrivileges.hiringSection.reviews) {
      sectionItems.push({
        label: "Reviews",
        iconType: "badge-check",
        ...getRouteAndSelected("adminAccountsReviews", currentPath),
      });
    }

    if (adminMenuPrivileges.hiringSection.commentReviews) {
      sectionItems.push({
        label: "Reviews Moderation",
        iconType: "notepad-problem",
        ...getRouteAndSelected("adminAccountsCommentReviews", currentPath),
      });
    }

    items.push({ label: "Hiring", items: sectionItems });
  }

  return { items };
}
